import { useEffect, useState } from "react";
import { GetRecoilCorporateList } from "../../store/corporateAtom";
import { Grid } from "@mui/material";
import { useParams } from "react-router-dom";
import StatusBadge from "../../generals/StatusBadge";

function CorporateScroll(props) {
  const corporateData = GetRecoilCorporateList();
  const [tableData, setTableData] = useState([]);
  const { corporate_id } = useParams();

  useEffect(() => {
    setTableData(
      corporateData.Corporate_Info.map((ele) => {
        return { ...ele, checked: false };
      })
    );
  }, [corporateData.Corporate_Info]);

  const onCheckboxClick = async (e, index) => {
    let element = tableData[index];
    tableData[index] = { ...element, checked: e.target.checked };
    await setTableData((prev) => {
      return [...tableData];
    });
    props?.onSelection(tableData);
  };

  return (
    <section className="mt-4 border rounded-lg bg-white shadow-sm h-[70vh] flex flex-col">
      {/* Scrollable List */}
      <div className="overflow-y-auto flex-1">
        {tableData?.map((corp, index) => (
          <div
            key={index}
            onClick={() => props.viewItemDetails(corp?.Corporate_Id)}
            className={`flex items-center p-3 border-b last:border-0 cursor-pointer transition-colors duration-150 
              ${
                Number(corporate_id) === corp?.Corporate_Id
                  ? "bg-blue-50 border-l-4 border-blue-500"
                  : "hover:bg-gray-50"
              }`}
          >
            <Grid container spacing={2} alignItems="center">
              {/* Checkbox */}
              <Grid item xs={1}>
                {/* <input
                  type="checkbox"
                  onChange={(e) => onCheckboxClick(e, index)}
                  checked={corp?.checked || false}
                  className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring focus:ring-blue-200"
                /> */}
              </Grid>

              {/* Corporate Info */}
              <Grid item xs={6}>
                <div className="ml-2">
                  <p className="font-semibold text-gray-800 text-sm">
                    {corp?.Corporate_Name}
                  </p>
                  <p className="text-xs text-gray-500 italic">
                    {corp?.Corporate_Email_Address}
                  </p>
                  <p className="text-sm text-gray-600">
                    {corp?.Corporate_Contact_Person_Mobile}
                  </p>
                </div>
              </Grid>

              {/* Status */}
              <Grid item xs={5}>
                <div className="ml-2">
                  <StatusBadge
                    statusId={corp?.Corporate_Approval_Status_Id}
                    statusName={corp?.Corporate_Approval_Status_Name}
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        ))}
      </div>
    </section>
  );
}

export default CorporateScroll;
